import { UseFormRegister, get } from 'react-hook-form';

/**
 * 電話番号フィールド基本コンポーネント
 */
export default function FormPhoneNumber(props: {
  // タイトル
  subject?: string;
  // name属性
  name: string;
  // プレースホルダー
  placeholder?: string;
  // 必須検証の有無
  required?: boolean;
  // 必須/任意のアイコン表示有無
  requiredMark?: boolean;
  // 読み取り専用
  readOnly?: boolean;
  // エラー情報
  errors: any;
  // クラス名
  className?: string;
  register: UseFormRegister<any>;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /* ----------------------------------------------------------------------- */
  /* プライベート関数 */
  /* ----------------------------------------------------------------------- */
  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  // 検証タイプの取得
  const type = get(props.errors, props.name)?.type ?? null;
  return (
    <>
      {props.subject && (
        <label className="form-label">
          {props.subject}
          {props.requiredMark && (
            <span className={props.required ? 'must' : 'any'}>{props.required ? ' *' : ''}</span>
          )}
        </label>
      )}
      <input
        className={
          get(props.errors, props.name)
            ? `is-invalid form-control ${props.className}`
            : `form-control ${props.className}`
        }
        {...{ name: props.name }}
        readOnly={props.readOnly ? true : false}
        placeholder={props.placeholder}
        type={'text'}
        {...props.register(props.name, {
          required: props.required,
          pattern: {
            value: /^\d{10,11}$/,
            message: '電話番号（半角数字10〜11桁）を入力してください。',
          },
        })}
        inputMode="tel"
      />
      {get(props.errors, props.name) && (
        <p className="error">
          {type === 'required' && <>必須項目です。</>}
          {get(props.errors, props.name)?.type === 'custom' && (
            <>{get(props.errors, props.name)?.message}</>
          )}
          {get(props.errors, props.name)?.type === 'pattern' && (
            <>{get(props.errors, props.name)?.message}</>
          )}
          {get(props.errors, props.name)?.type === 'validate' && (
            <>{get(props.errors, props.name)?.message}</>
          )}
        </p>
      )}
    </>
  );
}
